import { render } from "./ChartAxis.vue?vue&type=template&id=3fda807e"
import script from "./ChartAxis.vue?vue&type=script&lang=js"
export * from "./ChartAxis.vue?vue&type=script&lang=js"

import "./ChartAxis.vue?vue&type=style&index=0&id=3fda807e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__